module.exports = __webpack_public_path__ + "img/Sparepart.0a64577f.png";